import pkgUp from 'pkg-up';
import type toDesktopPackageJson from '../../package.json';
import readJson from './readJson';

type ToDesktopPackageJson = typeof toDesktopPackageJson;

const packageJson = readJson<ToDesktopPackageJson>(getPackageJsonPath());

export default function getToDesktopPackageJson(): ToDesktopPackageJson {
  return packageJson;
}

function getPackageJsonPath(): string {
  const packageJsonPath = pkgUp.sync({ cwd: __dirname });
  if (!packageJsonPath) {
    throw new Error('Could not locate package.json for @todesktop/cli');
  }

  return packageJsonPath;
}
